import React, { useState, useCallback, useMemo } from 'react';
import { Grid, Typography } from '@material-ui/core';
import ReactPlayer from 'react-player';
import { capitalize, formatWithoutCent } from '../../util/format';

import ModalProduct from '../ModalProduct';

const estampasWithGif = [
  'WILD HEARTS',
  'MACAW',
  'TROPICAL DESIRE',
  'DREAM GARDEN',
  'DANCING LEAFS',
  'MYSTIC JUNGLE',
];
const dictColor = {
  MIX: '#D1047D',
  BLACK: '#0C0A08',
  BEIGE: '#DFB08E',
  BLUE: '#0584C4',
  'BLUE + GREEN': '#0584C4',
  GREEN: '#2D6D4A',
  'BLUSH PINK': '#FAA19B',
  CARAMAEL: '#C07F45',
  BROWN: '#654321',
  'BEANIE BLACK MULTI': '#0C0A08',
  'LIGHT BLUE': '#ADD8E6',
  'LIGHT DENIM': '#BAC9D8',
  'MULTI NEON': '#00FFFF',
  'NEON ORANGE': '#FF6700',
  'NEON PINK': '#FF00FF',
  'RED MULTI': '#C81904',
  OCHER: '#C81904',
  'NEON YELLOW': '#FAED27',
  SAND: '#C2B280',

  'GREEN + LIGHT PINK': '#2D6D4A',
  'LIGHT PINK': '#FFBFB7',
  LILAC: '#8D5B8C',
  MULTI: '#4F3068',
  'MULTI ': '#4F3068',
  'NAVY BLUE': '#012F53',
  WHITE: '#FFF',
  'OFF WHITE': '#FEFBEC',
  'OFF-WHITE': '#FEFBEC',
  'OFF-WHITE + BLUE': '#0584C4',
  'RED + ORANGE | MULTI': '#4F3068',
  ORANGE: '#FF8A00',
  'BLACK AND WHITE': '#0C0A08',
  'TEAL BLUE': '#012F53',
  'DENIM BLUE': '#53A8D2',
  'PINK/YELLOW': '#EAABD4',

  'OFF WHITE + BLUE': '#0584C4',
  'OFF WHITE + GREEN': '#2D6D4A',
  'OFF-WHITE + GREEN': '#2D6D4A',
  'MUSK GREEN': '#2D6D4A',

  BURGUNDY: '#8D5B8C',

  PINK: '#EAABD4',
  RED: '#C81904',
  'WHITE MULTI': '#289168',
  'WHITE + BLUE': '#0584C4',

  'WHITE + MULTI': '#289168',
  YELLOW: '#FEBC41',
  CARAMEL: '#CF8846',

  'WHITE AND BLUE': '#0584C4',
  'OFF-WHITE GUIPIRE': '#FEFBEC',
  'RED AND BLUE': '#C81904',
  PURPLE: '#4F3068',
  'LIME GREEN': '#2d6d4a',
};
function LeftBarPrintDetail({
  setSelectedPrint,
  selectedPrint,
  products,
  handleNextPrint,
  handlePrevPrint,
  setProducts,
}) {
  const [open, setOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const handleClickOpen = product => {
    setOpen(true);
    setSelectedProduct(product);
  };
  const handleClose = () => {
    setOpen(false);
    setSelectedProduct(null);
  };
  const bgURL = useMemo(() => {
    if (estampasWithGif.includes(selectedPrint.name)) {
      return selectedPrint.other_images[0]
        .replace('2_mid', '2_large')
        .replace('.jpg', '.mp4')
        .replace('prints/mid', 'prints/large');
    }
    return selectedPrint?.other_images[0]
      ?.replace('Estampas_RESORT22_mid', 'Estampas_RESORT22_large')
      .replace('prints/mid', 'prints/large');
  }, [selectedPrint]);

  const handlePrevProduct = useCallback(() => {
    const selectedProductIndex = products.findIndex(
      p => p.style_code === selectedProduct.style_code
    );
    if (selectedProductIndex === 0) {
      // vou pro ultimo item
      const product = products.find(
        (p, index) => index === products.length - 1
      );
      setSelectedProduct(product);
    } else {
      // volto um item
      const product = products.find(
        (p, index) => index === selectedProductIndex - 1
      );

      setSelectedProduct(product);
    }
  }, [products, selectedProduct]);

  const handleNextProduct = useCallback(() => {
    const selectedProductIndex = products.findIndex(
      p => p.style_code === selectedProduct.style_code
    );
    if (selectedProductIndex >= products.length - 1) {
      setSelectedProduct(products[0]);
    } else {
      const product = products.find(
        (p, index) => index === selectedProductIndex + 1
      );
      setSelectedProduct(product);
    }
  }, [products, selectedProduct]);

  const bgPrint =
    selectedPrint.name === 'AMAZONIAN PATCH SCARF'
      ? '#000000'
      : selectedPrint.name === 'TROPICAL COLLAGE' ||
        selectedPrint.name === "TOUCAN'S GARDEN" ||
        selectedPrint.name === 'MANUELA FLORAL PASTEL'
      ? '#2D6D4A'
      : selectedPrint.name === 'BRAZILIAN MEMORIES'
      ? '#DFB08E'
      : selectedPrint.name === 'CASHEW FLOWERS' ||
        selectedPrint.name === 'OFF WHITE CASHEW SCARF' ||
        selectedPrint.name === 'WHITE SPOTTED BANANAS'
      ? '#FEBC41'
      : dictColor[selectedPrint.color] || '#474747';

  return (
    <Grid
      container
      justifyContent="flex-start"
      direction="row"
      style={{
        overflowX: 'hidden',
        position: 'relative',
        // width: '50%',
        height: '100%',

        // width: window.innerWidth * 0.5,
      }}
    >
      <Grid
        container
        direction="column"
        alignItems="center"
        // justifyContent="center"
        // alignItems="center"
        style={{
          // height: '100%',
          // top: '55.8%',
          // backgroundSize: 'stretch',
          // width: window.innerWidth * 0.9,
          top: '10%',
          position: 'fixed',
          left: -350,
          // top: 0,
          // right: 0,
          height: window.innerHeight * 0.885,

          // background: '#ffffff',
          // backgroundImage: `url(${selectedPrint.other_images[0] ||
          //   EstampaBG})  center center/contain no-repeat red`,
        }}
      >
        {bgURL && bgURL.includes('.mp4') ? (
          <ReactPlayer
            // style={{ width: 475, height: 'auto' }}
            loop
            url={bgURL}
            height="655px"
            width="563px"
            playing
            style={{
              height: 655,
              left: 120,

              width: 563,

              margin: '0px 5px 10px',
              position: 'fixed',
            }}
          />
        ) : (
          <img
            src={
              bgURL ||
              'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAY1BMVEX///9oaGhjY2NeXl5hYWFaWlrOzs5fX19YWFienp55eXnk5OT7+/uDg4OTk5P19fWfn5+/v7/q6urU1NSNjY23t7fIyMjc3NympqZra2uvr6+QkJCGhoa5ublzc3PZ2dlQUFC1P+9nAAAOHklEQVR4nO1d6dKquhLdZhBBBhVRnM/7P+UFP9EkpJMOhOitYlWdP2f7QRbp9JRO59+/GTNmzJgxY8aMGTNmzJgxY4YnpLvH4XbexJfrNcuy6z6P62q7PO6+PS4f2JVVnESc0ogxIoIxSjlfXOvtsfj2IIcifZyvDTdGFgY0VClf5Lfjt0frjOM5s5ETeTY0r9X624PGYxkzPLsPS07i8ttDx6DMOXVl92ZJef7jJHc1G0yvI8nq3xXXZcLH0XuR5Mnh21R0SCsycvoEUHZOv01IQVFz5oveE4zXv2QnG37epu8Nstr8DMfzBPz+ONY/IavbyCqfhEWNi8bJ6Z60uDcyyHnjyFk/DKO3b9P7d7xTM7eGWhJXh+NOno6iccbPedIQJUae0em7BjLNV2Z213NpjiB2S5t/x/dfXI4H2D407kmG9jTXt6vBESJ8OykLGMUVElBCo7h0VBJlDLtDNPvKNIITGA11Lh8xBZ5J+Be8nJwDYxnlch0ywPLwi7eR47A7aQdCVvlYt3m30XtHZBE06XHQqlBPnlZ6ZlqOq4CSutFJKKP+vOVKy5HHvp5vQxbp5NOvh6X1BKPM5ytAFLolyC++9Xkaa1YCOQUwG2uNQo/uU+TK1knf3pJo8gTAo78ECa8metlWI6p84sTjsi86NJlOjRdZfxpXk7riGiuxmmoC/3DTvHE53ev6BNlpaju8XvQkdTqKfRHl+VTvErDvSepUglr2CK7ChDXn/osnUTdr9T2EhUrdaoRngsWxU2WF3MMFbeueE8e8vzztvSKMB/XCUnUUycn3KxJFo9EQOuaNtca78fyFY0VMaDA3v8VaF8tEG5+v2CqvoLXPp9uw06cTfGY2VDUamCCU8Fr5U6jKk6lX+bABJNjA1zsuspaJgioZE0HiKT11kJcBufp5LA4mgr6WYqEQvPt4KBZmgg1FH4Y/k2WUhNzwshH0YhUP8kumcAhBWAk2Wm+0818oBENm1xEEPcjpXpJRFtKVQRFckP24t5SSmgmqZUCCRPYg+bhw+CQ/LOAihAlmivkaFWVUUtAyflXjARNM1DggGpELS6XXhDT1hhls/1kRreEGrJbUjBfrioOFoBIKkMGBQCE9J6CMggTfiYVaktPV0G8fS1OY+Bq/FXaCipySgUZMnsJVsJpIDEFl/2TgJG7EKSSjQqbd+liWy8NhK+JwOCyXZQPZBqEIKq4IGRSxyjHFGDVTJCvaIooi1iF64vm/Kb8LHJEEVQkbMryzuJjZiLxF2t95UEA+3w9LUFE27DxgYJK2oiNiptpeefpeA3iCirGm7uOSoib7J3pUedLMVbKvD6rAYBzoVWomqIsDK/HLUfegR0oB272G/17Fd4SsFIHWZHP7oKUzQeXTORszKUeJcBoo+OODpnKjB9bWkWoTv89H6ocvaQruas0khw2hqT6DU5XSDVMA3n4WV4L/UmkWXA2GOCyMLbyc2rLf5j+WKN7dGcUwdyeoWGxHXVOKMo4UgGK33hX9BVtjisDJHiYIh93SUqJue9+5OKxxkf0GVeZ+B39leruYB3T0usSPE9mDimb6GhwbrGU0/2OPYgiCmA4JLSVRcyEoC6nNVJxJswRBjD2pQDiLweyJOE4nMd04zH568ntaRkcSLNqRBuoSQ0k6ypLLUjdPJwFUfHGUPC88QUmv2bRwAH7N4KFJlOYCb/RFI22de0jLewU4CtEWgZ+hj6vwZzYhLcIwhDLbD0FMHbZpXHRwIIZgJnOQvRCjAWuS1JlhexafmA87uTAUzS3FFoNthWXIbIfHXBgSxmmS1+dzHe9PnDooYXj/RRosdiGKLptVP6VohmyVbUXTvT7gJxI2yqLeR+/ri4+2e+xIhpRUagyGiqteY4djI3EhEhzBVMhiIXbneBfcP6EbXbPydGeFHoaTfe/nvR5oSKOICxGZERT9BIRkJ3/I/pD0kWWXSuNYFmDKgtPTPcmuLdoH3hucYHUgxp/0gWIorl2bNRyOApo85lgZL0YJDLe3UrtPuzt65ZTvQbpWAYnKHJnKED2ayH3sFqTrclvvF6CIum9Suns1C+e/QKPcNGaQMoO9H7BlnYgDRv2F+6wjsV1Yw+Ehxc3iJiBqO1hM71g9mgZ5rMWmQV1vPm98nBCp4fvlkisPzFvEBhUi5r5RtRSiscAkBlYExupjxjZG6/eRGj1MBZ9iyhnlmYrZHcwfmHyaT55Md2bRAaas+8NxSiRziJl0A8PPOTM4WSiMzsTQMIfSssIYREmsEQsXZvjR/Gqlv+7Hp+M/2E81MRQNImofUTL4iN/DDN9TmNtd7Kh1gCvwd0alLip/zE6uqHwR5gWOnt77DUt7+MFyy7NM2SKXrFILKaE/hmHUhROIPeBXCBND0mwcufg7jM8nRiMIDwNm2Ik4YvOpW7EP0JkzMRRqa1C1mKJbitiTARl2YTkqCdDtUEI2xcjw3v9URmRuDME8TSekW0wk32n5HBBT49aC4JiiHGlfDLvA6w78u8wgM3+On2T40lIFzlt7iSlU1mBkKEppQIadVkMVKrzdLWjRohli1uHVTZeCDF/eBWqT+2Oqh6xDV116cbOHEMNOd1yQDF8fPwH+2cRQ/B3GHopWF1HfAMlV5+VnyLTvS1yu+p8bGQrrAOXTOPqlIMPSjeHrYwK7/kaGrn6p6IIgUm02hoDYeWToHFs4xoc2KcVua7ycfEhKDevLOT6UkgL2HDLE8OXSoDyaFi/DBGkag450TbtI3m9kr2mEGP7JC5i671F4TRJkLQwMnfM0OzexNtpoMHXfw+tN4NMMDJ1zbeJLMMoXWmgnXbMHEK/1cIS8NgND53ypJCiIulTQ80413XNghn8Pg7YUTQwzt6SE8hcIgwgqy5NDArETFkCVGhm671uIlVQIufZSi/Eq8ITDaZjhgL0nUVIQ2tcHw+7bg4GIwR4O2D8UzQVCmfpg2B05Ah0gg08zYA9YmnZ7vOWBYXe8+AhnE2GGA/bx5Wq4EAy7MBTSM0aGkn3BEZRCOnu933iGnTrT9POzM5TqabCF0JVLTdR4hu/aUUPOCh67UwFXh6NLXdtohrzTDqbMMcxQqqNENzkTB221+eMYfprnHk0eEMzQaaxviF6NtaIGX9emGfjqPfLC6AGBDMth9aXVBDXCJLmdlB7IhCdvsUr1rZetDEW326FGWKrztpXU4Biy1odfn5O2w/wTEWfxZ9mklk1ikOHQw13SyT6LmKIYRp3CSh+3eJ9k+3orDmdnO2YKSdJjQGXiE9IuqUVMMQwtraVKayYAGoTLQOFXWjQUgqHl3YhCFOgJ0rEJpypDaSGakzWYOSSGVtilTskiGUqxiNO5J2kfDz7/1wJXBU2gdu2PBPf3eoZSSZvb2TX8+UNsnXdj+nqhTbG9I6+o0Ye26+FCqpwhNS0jfK0+oSw+vHMGxaPK8Dco6RlKhQ0Op56eQJ8Ddjpv0VhBTpLrNbtb7w1EMJQ2X51buEgHUE2R/oAzM87nSQCG0iw4n+WWC7UMcTDQetMzdAzlo9zuzWWwPRUCMdTIoBRtDeipgO2LgWqZMJ5hfw7lvhiueqaFVEYH9zYJw5D3s5rje5vIhg7MYjkc7RkOTeNpuYplWLsvSVVBHkO/Ufv7L+Dj3W6I6EpjkKUKiIHdvpQuPtocSK9R+4dfXS794LDUyI+cWh3a7EvuhqCrHjI0zJm4uZuUlxt8aELp19bPEeygNchGNqS0Qm53OLhfm9L/qLcPVUCuyeQEZUdqRBMrpW+i4jZ8j6BSGT+midVN7n0pyWkBeZds8g6SlfTlo1H3XMpNJsW+e+AM+j4N1sdOVuDjbkkoFa/z8xZIyUxPUO3tOfIQqFyF9d5sduzK5RW5fkhDoYR/9M//A53RAASVexrGn3LdymSe1/TAPZ2mJ6hs4PjoqqqUTzZW8ZsElTIyL2/spSnAQz4BCP5TNnD8nMRWLygBK0ICEFQFylOLeFy3rhCXBymH4Hzdb4FrlBSCYKyqcG9PBqPAsARrhaDP1sbqUvwJgn4vs7a0LAtBcKMQ9H1Pg/EkbwgtmisEB6SAzejduxaY4LVno7zfBgPfp+H9a/bRL2SgE1xEAflqAQiue8H2NB3i9V2PAtxb0r/+dKprOjVX5S4W98lvR4p7wjPdVauay3KRdcfDsbv3DNWUl6xrKE581aPuPuBJb2TSCCo7TXcvhPZO5wkvPG6h24lRu7B7Q6Wp1Jj20uoWunM7bDHFa493zascurAOhrbKju9978QUF439/dTbToo00dbCGgq7BryjXmm+I0tCXdyX69wbRofsNGuRnrWlUkFuAX9Bfyqt4ehDVotaXysV6BbwF/qe4h9HHo/VBOtcJ5/tEgx2WdEf0qs+1iC6Pp54HBKglI9PvmPXxxYYC4l4jDtgpaLMOZCpJEFvlnyjSMDdCxrFrhayjBnYc5BOXRUA4gZXhxLKrzfsyllv9xxuqUhC3kqoorgaknCEUZ6dl2YbXTyqfcRNhZj+nQk3lObTvqSZS57k58NjLY8z3R2Xt82V2MpM6WnYmvaJyn6DBWERbZhGi/uzsfD9RNpLaYx9TP/A6Kg9el/Qe1ge4NkTHINiMwFHwjffXYAyIE9rMBh0fOF7SM+wPXMFoaT6FfmUALpcjvzGOX7TYleTkRNJKKtDXm4+AI1zOZhkYzzzydMwPlDGxOil6NkxTpyd2S9iXWUOh2Ke/l0VOP7zgGN1eTplxp3HlhzZV+hj5j+H4nHbZM9LyxiTGnSzxpHjnGXxrfw1uzcErZu9reo4z/f763W/z+P6vD08dj9p82bMmDFjxowZM2bMmDFjxoz/T/wPcKqtaCSHCKsAAAAASUVORK5CYII='
            }
            style={{
              height: 'auto',
              left: 120,

              width: 563,

              margin: '0px 5px 10px',
              position: 'fixed',
            }}
            alt="img"
          />
        )}
        <Grid
          style={{
            background:
              bgURL && bgURL.includes('.mp4') ? null : 'rgba(0, 0, 0, 0.05)',
            height: 655,
            width: 563,
            margin: '0px 5px 10px',

            left: 120,
            position: 'fixed',
          }}
        >
          <Typography
            onClick={() => {
              setSelectedPrint(null);
              window.scrollTo(0, 0);
            }}
            style={{
              position: 'fixed',
              left: 180,
              color:
                selectedPrint.color === 'OFF-WHITE' ||
                selectedPrint.color === 'OFF WHITE'
                  ? '#000'
                  : '#FFF', // backgroundColor: 'red',
              textAlign: 'left',
              zIndex: 100,
              // marginRight: window.innerWidth / 9,
              marginTop: 40,
              cursor: 'pointer',
              background: bgPrint,
              // position: 'absolute',
            }}
          >
            {'< '}Back to prints
          </Typography>
          {/* </Grid> */}

          {/* <Grid style={{ backgroundColor: 'red', width: 300 }}> */}
          <Typography
            onClick={() => {
              setSelectedPrint(null);
              window.scrollTo(0, 0);
            }}
            style={{
              position: 'fixed',
              left: 180,
              color:
                selectedPrint.color === 'OFF-WHITE' ||
                selectedPrint.color === 'OFF WHITE'
                  ? '#000'
                  : '#FFF', // backgroundColor: 'red',
              textAlign: 'left',
              zIndex: 100,
              // marginRight: window.innerWidth / 9,
              marginTop: 40,
              cursor: 'pointer',
              background: bgPrint,

              // position: 'absolute',
            }}
          >
            {'< '}Back to prints
          </Typography>
          {/* </Grid> */}

          <Grid
            style={{
              // backgroundColor: 'red',
              zIndex: 3000,
              position: 'fixed',
              top: 430,
              left: 195,
            }}
          >
            <Typography
              align="center"
              onClick={handleNextPrint}
              style={{
                color:
                  selectedPrint.color === 'OFF-WHITE' ||
                  selectedPrint.color === 'OFF WHITE'
                    ? '#000'
                    : '#FFF',
                cursor: 'pointer',
                fontSize: 14,
                lineHeight: '20px',
                background: bgPrint,
                marginBottom: 10,
                width: 70,
                height: 25,
                marginLeft: 18,
              }}
            >
              {' '}
              {'> '}Next
            </Typography>
            <Typography
              align="center"
              onClick={handlePrevPrint}
              style={{
                color:
                  selectedPrint.color === 'OFF-WHITE' ||
                  selectedPrint.color === 'OFF WHITE'
                    ? '#000'
                    : '#FFF',
                cursor: 'pointer',
                fontSize: 14,
                lineHeight: '20px',
                background: bgPrint,
                width: 70,
                height: 25,
                marginLeft: 18,
              }}
            >
              {' '}
              {'< '}Prev
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      {/* <Grid style={{ position: 'relative' }}> */}
      <Grid
        style={{
          minHeight: 350,

          background: bgPrint,
          top: '23%',
          position: 'fixed',
          left: 335,
          width: 370,
          zIndex: 50,
        }}
      >
        <Grid
          container
          // container
          // direction="column"
          // justifyContent="center"
          // alignItems="center"
        >
          <Typography
            align="center"
            style={{
              fontSize:
                selectedPrint.name === 'AMAZONIAN PATCH SCARF'
                  ? 24
                  : selectedPrint.name === 'BRAZILIAN MEMORIES' ||
                    selectedPrint.name === "TOUCAN'S GARDEN" ||
                    selectedPrint.name === 'ARARAS COLORIDAS' ||
                    selectedPrint.name === 'BOROGODO'
                  ? 26
                  : 29,
              color:
                selectedPrint.color === 'OFF-WHITE' ||
                selectedPrint.color === 'OFF WHITE'
                  ? '#000'
                  : '#FFF',
              maxWidth: 180,
              left: -192,
              top: 0,
              position: 'absolute',
              alignItems: 'center',
              background: bgPrint,
              overflowWrap: 'break-word',
            }}
          >
            {selectedPrint && selectedPrint.name.includes('MULTICOLORED')
              ? selectedPrint.name.replace('MULTICOLORED', 'MULTI COLORED')
              : selectedPrint.name.includes('HEARTBERRY')
              ? selectedPrint.name.replace('HEARTBERRY', 'HEART BERRY')
              : selectedPrint.name.includes('PATCHWORK')
              ? selectedPrint.name.replace('PATCHWORK', 'PATCH WORK')
              : selectedPrint.name.includes('+')
              ? 'MIXED PRINT'
              : selectedPrint.name}
            {/* BURGUNDY ETHNIC BANANAS */}
          </Typography>
          {products.map((product, index) => (
            <Grid
              container
              style={{ paddingLeft: 15, marginLeft: 20, marginBottom: 1 }}
            >
              <Grid
                container
                style={{ cursor: 'pointer' }}
                onClick={() => handleClickOpen(product)}
              >
                <Grid>
                  <Grid
                    style={{ width: 300 }}
                    container
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Grid>
                      <Typography
                        // variant="body2"
                        style={{
                          color:
                            selectedPrint.color === 'OFF-WHITE' ||
                            selectedPrint.color === 'OFF WHITE'
                              ? '#000'
                              : '#FFF',
                          paddingTop: 3,
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          maxWidth: '220px',
                        }}
                      >
                        {capitalize(
                          product.description.replace(selectedPrint.name, '')
                        )}
                      </Typography>
                    </Grid>
                    <Grid>
                      <Typography
                        align="center"
                        variant="body2"
                        style={{
                          color:
                            selectedPrint.color === 'OFF-WHITE' ||
                            selectedPrint.color === 'OFF WHITE'
                              ? '#000'
                              : '#FFF',
                          marginTop: 3,
                          fontSize: 12,
                        }}
                      >
                        {product.style_code}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid>
                    <Typography
                      style={{
                        color:
                          selectedPrint.color === 'OFF-WHITE' ||
                          selectedPrint.color === 'OFF WHITE'
                            ? '#000'
                            : '#FFF',
                        fontSize: 12,
                        margin: '2px 0px',
                      }}
                    >
                      {product.fabric_code} {capitalize(product.composition)}
                    </Typography>
                  </Grid>
                  <Grid
                    style={{ width: 300, margin: '2px 0px' }}
                    container
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    {' '}
                    <Typography
                      style={{
                        color:
                          selectedPrint.color === 'OFF-WHITE' ||
                          selectedPrint.color === 'OFF WHITE'
                            ? '#000'
                            : '#FFF',
                        fontSize: 12,
                      }}
                    >
                      Wholesale {formatWithoutCent(product.wholesale_usd)}{' '}
                      &euro;{product.wholesale_eur}
                      {product.wholesale_lib
                        ? ` £${product.wholesale_lib}`
                        : ''}
                    </Typography>
                    <Typography
                      style={{
                        color: '#fafafa',
                        fontSize: 12,
                      }}
                    >
                      {' '}
                      MSRP {formatWithoutCent(product.msr_price_usd)} &euro;
                      {product.msr_price_eur}
                      {product.msr_price_lib
                        ? ` £${product.msr_price_lib}`
                        : ''}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          ))}
          {selectedPrint && selectedPrint.name.includes('+') ? (
            <Grid
              container
              style={{ paddingLeft: 15, marginLeft: 20, marginBottom: 5 }}
            >
              <Grid style={{ marginTop: 20 }}>
                <Typography
                  style={{
                    color: '#fafafa',
                    fontSize: 12,
                  }}
                >
                  Print
                </Typography>
                <Typography
                  style={{
                    color: '#fafafa',
                    fontSize: 12,
                    width: 300,
                  }}
                >
                  {selectedPrint.name}
                </Typography>
              </Grid>
            </Grid>
          ) : null}
          {selectedProduct && (
            <ModalProduct
              products={products}
              setProducts={setProducts}
              handlePrevProduct={handlePrevProduct}
              handleNextProduct={handleNextProduct}
              open={open}
              handleClose={handleClose}
              product={selectedProduct}
            />
          )}
        </Grid>
      </Grid>
      {/* </Grid> */}
    </Grid>
  );
}

export default LeftBarPrintDetail;
